module.exports = __webpack_public_path__ + "img/plus.2f2e5c42.svg";